import React, { useState, useEffect } from 'react';
import { List, Radio, Icon, Button, Empty, Pagination } from 'antd';
import { BeneficiaryModal } from '../../BeneficiaryModal';
import { Beneficiary } from '../../../../models';
import { alertify, handleApiExceptions } from '../../../../app_methods';
import { Text3, Text4 } from '../../../../styles';
import { connect } from 'react-redux';
import { updateCurrentUserAction } from '../../../../redux/actions';


const BeneficiaryList = (props) => {
    const [beneficiaries, setBeneficiaries] = useState([]);
    const [pagination, setPagination] = useState({
        pageSize: 10,
        total: 0,
        current: 1
    });
    const [isCreating, setIsCreating] = useState(false);
    const [showBeneficiaryModal, setShowBeneficiaryModal] = useState(false);

    const fetchBeneficiaries = async (_pagination) => {
        if (!props.current_user.key) return;
        props.setIsLoading(true);
        const response = await Beneficiary.list({ pageSize: _pagination.pageSize, current: _pagination.current, contact_id: props.selectedContact.uuid, is_active: true});
        if (!response.success) {
            props.setIsLoading(false);
            handleApiExceptions(response);
            return;
        }
        setBeneficiaries(response.data.results);
        setPagination({ ...pagination, total: response.data.count });
        props.setIsLoading(false);
    };

    const saveBeneficiary = async (values) => {
        setIsCreating(true);
        const beneficiary = new Beneficiary(values);
        const response = await beneficiary.save();
        if (!response.success) {
            setIsCreating(false);
            handleApiExceptions(response);
            return;
        }
        const message = response.message || "Beneficiary created successfully.";
        alertify("Success", message, "success");
        toggleBeneficiaryModal();
        setIsCreating(false);
        fetchBeneficiaries(pagination);
    };

    const toggleBeneficiaryModal = () => {
        setShowBeneficiaryModal(!showBeneficiaryModal);
    };

    const handleBeneficiarySelection = (e) => {
        props.handleBeneficiarySelection(beneficiaries.find(c => c.uuid == e.target.value));
    };

    const handlePaginationChange = (e) => {
        const _pagination = { ...pagination, current: e };
        setPagination(_pagination);
        fetchBeneficiaries(_pagination);
    };

    useEffect(() => {
        fetchBeneficiaries(pagination);
    }, []);

    const renderCreateButton = (type = "primary", size = "default") => {
        return (
            <Button size={size} type={type} onClick={toggleBeneficiaryModal}>
                <Icon type="plus" /> New Beneficiary
            </Button>
        )
    };

    const renderBankDetails = (beneficiary) => {
        return (
            <>
                <Text4 className="ml-1" type="secondary">・ {beneficiary.account_number}</Text4>
                <Text4 className="ml-1" type="secondary">・ {beneficiary.account_ifsc}</Text4>
            </>
        )
    };

    const renderUpiDetails = (beneficiary) => {
        return (
            <>
                <Text4 className="ml-1" type="secondary">・ {beneficiary.upi_handle}</Text4>
            </>
        )
    };

    const renderBeneficiaryDetails = (beneficiary) => {
        return (
            <>
                <Icon type={`${beneficiary.beneficiary_type == "bank_account" ? "bank" : "qrcode"}`} />
                <Text4 className="ml-2 mb-2" strong>
                    {beneficiary.beneficiary_type_display} ({beneficiary.account_name})
                </Text4>
                {
                    beneficiary.beneficiary_type == "bank_account" ? renderBankDetails(beneficiary) : renderUpiDetails(beneficiary)
                }
            </>
        )
    };

    const renderPagination = () => {
        return (
            <div className="d-flex justify-content-end">
                <Pagination
                    size="small"
                    pageSize={pagination.pageSize}
                    total={pagination.total}
                    current={pagination.current}
                    onChange={handlePaginationChange}
                />
            </div>
        )
    };

    return (
        <div>
            {
                beneficiaries.length ?
                    <div>
                        <div className="mb-2 w-10 d-flex justify-content-end">
                            {renderCreateButton("link", "small")}
                        </div>
                        <Radio.Group className="w-100 mb-2" value={props.selectedBeneficiary && props.selectedBeneficiary.uuid} onChange={handleBeneficiarySelection}>
                            <List
                                className="w-100"
                                dataSource={beneficiaries}
                                renderItem={item => (
                                    <List.Item>
                                        <div>
                                            <Radio value={item.uuid}>
                                                {renderBeneficiaryDetails(item)}
                                            </Radio>
                                        </div>
                                    </List.Item>
                                )}
                            />
                        </Radio.Group>
                        {renderPagination()}
                    </div>
                    :
                    <div>
                        <Empty
                            className="mt-4 mb-2 align-items-center"
                            description={
                                <Text3 type="secondary">No beneficiaries for this contact.</Text3>
                            }
                        />
                        <div className="d-flex justify-content-center">
                            {renderCreateButton("dashed", "default")}
                        </div>
                    </div>
            }
            <BeneficiaryModal
                visible={showBeneficiaryModal}
                toggleBeneficiaryModal={toggleBeneficiaryModal}
                contact={props.selectedContact}
                onSubmit={saveBeneficiary}
                loading={isCreating}
            />
        </div>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(BeneficiaryList);